import i18n from '@/i18n/i18n';
import JsBarcode from 'jsbarcode';

export function printHtml(htmlData, usePopup = false) {
	const htmlContent = htmlData;
	const printWindow = window.open('', '_blank', usePopup ? { popup: true } : null);
	if (!printWindow) {
		alert(i18n.t('messages.no-permission-to-print'));
	} else {
		printWindow.document.write(htmlContent);
		printWindow.document.close();
		printWindow.addEventListener('load', () => {
			printWindow.onafterprint = () => printWindow.setTimeout(printWindow.close);
			printWindow.print();
		})
	}
}

export function downloadBlob(blob, fileName) {
	const url = URL.createObjectURL(blob);
	const a = document.createElement('a');
	a.href = url;
	a.download = fileName || true;
	a.click();
	a.remove();
}

export function fixNumber(number, digits = 4) {
	return Number((number).toFixed(digits));
}

export const generateBarcode = (selector, data, options = {}, heightInCm = 4) => {
	const PPIElement = document.createElement('div');
	PPIElement.id = 'ppi';
	PPIElement.style.width = '1in';
	PPIElement.style.visibility = 'hidden';
	PPIElement.style.position = 'absolute';
	document.body.append(PPIElement);
	const PPI = PPIElement.offsetWidth || 96;
	
	JsBarcode(selector, data, {
		fontSize: 32,
		fontOptions: 'bold',
		margin: 0,
		width: 3,
		height: Math.round(heightInCm * (PPI / 2.54)),
		// background:	'#ffffff',
		background:	'transparent',
		lineColor: '#000000',
		...options
	});

	PPIElement.remove();
}

export const isRouteForbiddenDuePermissions = (routeName, permissions) => {
	switch (routeName) {
	case 'stores': return permissions.stores.isNone;
	case 'store-info': return permissions.configs.isNone;
	case 'items-tree': return permissions.itemTree.isNone;
	case 'accounts-tree': return permissions.accountTree.isNone;
	case 'account-statement': return permissions.accountStatement.isNone;
	case 'all-invoices': return permissions.allInvoices.isNone;
	case 'sale-invoice': return permissions.saleInvoice.isNone;
	case 'pruchase-invoice': return permissions.buyInvoice.isNone;
	case 'sales-invoice-returned': return permissions.saleRefundInvoice.isNone;
	case 'journals': return permissions.allCashJournal.isNone;
	case 'cashbox-journal':
	case 'accounting-journal': return permissions.cashJournal.isNone;
	case 'closing-cashbox-journal': return permissions.closedCashJournal.isNone;
	case 'daily-journal': return permissions.detailedDay.isNone;
	case 'all-journals': return permissions.allItemJournals.isNone;
	case 'journal-item': return permissions.itemJournal.isNone;
	case 'statement-item': return permissions.itemStatement.isNone;
	case 'item-inventory': return permissions.inventoryReport.isNone;
	case 'funds-journal-table': return permissions.dailyTable.isNone;
	case 'reports': return permissions.reports.isNone;
	default: return false;
	}
}